import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check, Minus, X } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    indicator?: 'check' | 'x'
  }
>(({ className, indicator = 'check', checked, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    checked={checked}
    className={cn(
      `data-[state=unchecked]:group-hover:bg-text-primary/5 grid place-content-center peer size-6 shrink-0 rounded-[2px] bg-field-2 border border-strong-01 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-success/15 data-[state=checked]:border-success data-[state=checked]:text-success data-[state=indeterminate]:bg-success/15 data-[state=indeterminate]:border-success data-[state=indeterminate]:text-success`,
      {
        'data-[state=checked]:bg-error-solid data-[state=checked]:text-error-solid-fg data-[state=checked]:border-error':
          indicator === 'x',
      },
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('grid place-content-center text-current')}>
      {checked === 'indeterminate' ? (
        <Minus className="size-4" />
      ) : indicator === 'x' ? (
        <X className="size-4" />
      ) : (
        <Check className="size-4" />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
